interface TimezoneGroup {
  name: string;
  timezones: Timezone[];
}

interface Timezone {
  name: string;
  iana: string;
}

export function getCurrentTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Chicago";
}

export const timezones: TimezoneGroup[] = [
  {
    name: "North America",
    timezones: [
      { name: "Eastern Time (US & Canada)", iana: "America/New_York" },
      { name: "Central Time (US & Canada)", iana: "America/Chicago" },
      { name: "Mountain Time (US & Canada)", iana: "America/Denver" },
      { name: "Pacific Time (US & Canada)", iana: "America/Los_Angeles" },
      { name: "Alaska Time", iana: "America/Anchorage" },
      { name: "Hawaii Time", iana: "Pacific/Honolulu" },
    ],
  },
  {
    name: "Europe",
    timezones: [
      { name: "Greenwich Mean Time", iana: "Etc/Greenwich" },
      { name: "British Time", iana: "Europe/London" },
      { name: "Central European Time", iana: "Europe/Paris" },
      { name: "Eastern European Time", iana: "Europe/Bucharest" },
    ],
  },
  {
    name: "Asia",
    timezones: [
      { name: "India Standard Time", iana: "Asia/Kolkata" },
      { name: "China Standard Time", iana: "Asia/Shanghai" },
      { name: "Japan Standard Time", iana: "Asia/Tokyo" },
      { name: "Korea Standard Time", iana: "Asia/Seoul" },
      { name: "Singapore Time", iana: "Asia/Singapore" },
    ],
  },
  {
    name: "Australia & Pacific",
    timezones: [
      { name: "Australian Eastern Time", iana: "Australia/Sydney" },
      { name: "Australian Central Time", iana: "Australia/Adelaide" },
      { name: "New Zealand Time", iana: "Pacific/Auckland" },
      { name: "Fiji Time", iana: "Pacific/Fiji" },
    ],
  },
  {
    name: "South America",
    timezones: [
      { name: "Brasília Time", iana: "America/Sao_Paulo" },
      { name: "Argentina Time", iana: "America/Argentina/Buenos_Aires" },
      { name: "Chile Time", iana: "America/Santiago" },
    ],
  },
  {
    name: "Africa",
    timezones: [
      { name: "West Africa Time", iana: "Africa/Lagos" },
      { name: "South Africa Standard Time", iana: "Africa/Johannesburg" },
      { name: "East Africa Time", iana: "Africa/Nairobi" },
    ],
  },
] satisfies TimezoneGroup[];

const ianaToName: Record<string, string> = {};
timezones.forEach(({ timezones }) =>
  timezones.forEach(({ iana, name }) => (ianaToName[iana] = name)),
);

export function lookupHumanIana(iana: string): string | undefined {
  return ianaToName[iana];
}
